import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './AppIcon';
import Image from './AppImage';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Функции', path: '/hero-landing' },
      { label: 'Цены', path: '/pricing-plans' },
      { label: 'Демо', path: '/demo-playground' },
      { label: 'Интеграции', path: '/hero-landing' },
      { label: 'Privacy Policy', path: '/privacy' }
    ]
  };

  const socialLinks = [
    { name: 'WhatsApp', icon: 'MessageCircle', url: 'https://wa.me/77476660065' },
    { name: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/jetu.app/' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to="/hero-landing" className="flex items-center space-x-3 group mb-4">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-105 overflow-hidden bg-transparent">
                <Image 
                  src="/assets/images/jetu-logo.png" 
                  alt="Jetu AI" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-xl font-headline font-bold text-foreground">
                Jetu AI
              </span>
            </Link>
            
            <p className="text-muted-foreground text-sm mb-6 max-w-sm">
              Платформа интеллектуальной автоматизации, которая улучшает бизнес-операции через продвинутую оркестрацию AI и бесшовную интеграцию.
            </p>

            <div className="flex items-center space-x-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-muted hover:bg-accent hover:text-accent-foreground flex items-center justify-center transition-all duration-200 hover:scale-105"
                  aria-label={social?.name}
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-headline font-semibold text-foreground mb-4">
              Продукт
            </h3>
            <ul className="space-y-3">
              {footerLinks?.product?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-muted-foreground hover:text-accent transition-colors duration-200 text-sm"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline font-semibold text-foreground mb-4">
              Контакты
            </h3>
            <Link
              to="/contact-support"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-accent to-primary text-white rounded-lg hover:opacity-90 transition-opacity duration-200 text-sm font-medium"
            >
              <Icon name="MessageSquare" size={18} />
              Связаться с нами
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-muted-foreground text-sm">
              © {currentYear} Jetu AI Платформа. Все права защищены.
            </p>
            
            <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6">
              <div className="flex items-center space-x-2 text-muted-foreground text-sm">
                <Icon name="Shield" size={16} />
                <span>Корпоративная безопасность</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground text-sm">
                <Icon name="Lock" size={16} />
                <span>Соответствует GDPR</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground text-sm">
                <Image 
                  src="/assets/images/astana-hub-logo.svg" 
                  alt="Astana Hub" 
                  className="h-6 w-auto opacity-90"
                  style={{ maxHeight: '24px' }}
                />
                <span>Участник Astana Hub</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;